import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTeam$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTeam extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '806f095883e34b02383288a0e7102c8cfed85036', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c10ae6c1737dc71755916bb28bafcd05ec761abf', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1a01a27ac7039dc065271e4679af7787bfefdfb3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.57 6.21c.403.503.56 1.159.43 1.79l-.36 2.47a2.05 2.05 0 0 1-2.17 1.9 2.05 2.05 0 0 1-2.17-1.9L5 8a2.12 2.12 0 0 1 .57-1.79 2.6 2.6 0 0 1 2-.8 2.58 2.58 0 0 1 2 .8m7 0c.403.503.56 1.159.43 1.79l-.36 2.47a2.05 2.05 0 0 1-2.17 1.9 2.05 2.05 0 0 1-2.17-1.9L12 8a2.12 2.12 0 0 1 .57-1.79 2.6 2.6 0 0 1 2-.8 2.58 2.58 0 0 1 2 .8M10 13.24a.5.5 0 0 0-.51 0 3.57 3.57 0 0 1-3.87 0 .52.52 0 0 0-.51 0A3.5 3.5 0 0 0 3 16.34v.16a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-.16a3.47 3.47 0 0 0-2-3.1m3.53.94A5.8 5.8 0 0 1 14 16.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-.16a3.47 3.47 0 0 0-2.05-3.06.5.5 0 0 0-.51 0 3.4 3.4 0 0 1-1.93.57q-.338 0-.67-.06c-.31-.06-.44.12-.31.39", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-team", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-team"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-team":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTeam$1);
            }
            break;
    } });
}

const CosmosIconTeam = CosmosIconTeam$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTeam, defineCustomElement };
